/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

//*************** Libreria para realizar pdfs **************************************/
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ------------------- CONSULTAS A LA API --------------------------------
import { obtenerProductosCodigo } from "../../../../../API/Global/Productos/ProductosRequests";

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import JsBarcode from 'jsbarcode';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const EtiquetaProducto = () => {
  const { CodigoP } = useParams();

  const obtenerInformacion = async () => {
    const codigos = CodigoP.split(',');
    const promesasProductos = codigos.map(codigo => obtenerProductosCodigo(codigo));
    const productosTempo = await Promise.all(promesasProductos);
    const productos1 = productosTempo.flat();
    generarPDF(productos1);
  };

  useEffect(() => {
    if (CodigoP) {
      obtenerInformacion(CodigoP);
    }
  }, [CodigoP]);

  const generarPDF = (productosTempo) => {
  
    const contenido = [];
  
    productosTempo.forEach((producto, index) => {
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, producto.CodigoProducto, {
        format: 'CODE128',
        width: 2,
        height: 80,
        displayValue: false,
      });
  
      const codigoBarrasURL = canvas.toDataURL('image/png');      

      contenido.push({
        stack: [
          {
            table: {
              widths: ["70%", "30%"],
              body: [
                [
                  {
                    image: codigoBarrasURL,
                    width: 100,
                    height: 45,
                    margin: [0, 0, 0, 0],
                  },
                  {
                    stack: [
                      { 
                        text: `${producto.CodigoProducto || ''}`, 
                        style: "titulo" 
                      }, 
                      { 
                        text: `${producto.NombreCategoria || ''}`, 
                        style: "infoGeneral2", 
                        margin: [0, 5, 0, 0] 
                      }, 
                    ],
                    margin: [-40, 5, 0, 0],
                  },
                ],
              ],
            },
            layout: "lightHorizontalLines",  
          },
          {
            // text: `${producto.NombreProducto || ''}`,
            text: `${producto?.NombreProducto?.substring(0, 80) || ''}`,
            style: "infoGeneral", 
            margin: [0, -3, 0, 0], 
          },
          index < productosTempo.length - 1 ? { text: '', pageBreak: 'after' } : null,
        ],
      });
    });
  
    const docDefinition = {
      pageSize: {
        width: 210,
        height: 72,
      },
      pageMargins: [10, 0, 10, 0],
      content: contenido,
      styles: {
        titulo: {
          fontSize: 10.5,
          bold: true,
          alignment: "center",
        },
        infoGeneral: {
          fontSize: 8,
          bold: true,
          alignment: "center", 
        },
        infoGeneral2: {
          fontSize: 9,
          alignment: "center",
        },
      },
    };
    pdfMake.createPdf(docDefinition).open({}, window);
  };
  
};

export default EtiquetaProducto;
